import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import type { CSSProperties, ReactNode } from "react";

interface BookShipmentSectionProps {
  header: ReactNode;
  description?: ReactNode | undefined;
  children?: ReactNode | undefined;
  index: number;
  id?: string | undefined;
  minHeight?: string | undefined;
}

/**
 * A section with a plain header instead of a numbered StepHeader — the address
 * screens group several of these under one step.
 *
 * Sizing mirrors BookShipmentSection: a max-width container plus
 * `align="stretch"`, so every panel in the column is the same width. Do not use
 * `items-start` here — it shrink-wraps each child to its own content, which is
 * how Contact Details, Pickup Reference Number and Notes ended up three
 * different widths.
 */
function BookShipmentSmallSection(props: BookShipmentSectionProps) {
  // minHeight is per-section (some reserve space so the page doesn't jump
  // while their content loads), so it stays an inline style.
  const style: CSSProperties = { marginBottom: "64px" };
  if (props.minHeight) {
    style.minHeight = props.minHeight;
  }

  return (
    <div style={style} id={props.id} className="w-full max-w-[824px]">
      <Stack gap={3} align="stretch">
        <div>
          {props.header && (
            <T size="lg" weight="medium">
              {props.header}
            </T>
          )}
          {props.description && (
            <div className="max-w-[618px]">
              <T size="sm" weight="light" color="muted">
                {props.description}
              </T>
            </div>
          )}
        </div>
        {props.children}
      </Stack>
    </div>
  );
}
export default BookShipmentSmallSection;
